import React from 'react';
import { useTheme } from '../context/ThemeContext';

export type TimeRange = '30' | '90' | '365' | 'all';

export const TIME_RANGE_TO_OPTIONS = (range: TimeRange): { days?: number; allTime?: boolean } => {
  if (range === 'all') return { allTime: true };
  return { days: parseInt(range, 10) };
};

interface HistorySearchBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder: string;
  timeRange: TimeRange;
  onTimeRangeChange: (value: TimeRange) => void;
}

// Shared search + time-range control for the Tasks, Quick Tasks, and Releases lanes.
// All three load only the last 30 days by default; this lets the user search (which
// searches full history regardless of range) or explicitly widen/narrow the window.
const HistorySearchBar: React.FC<HistorySearchBarProps> = ({
  search,
  onSearchChange,
  searchPlaceholder,
  timeRange,
  onTimeRangeChange,
}) => {
  const { theme } = useTheme();
  return (
    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
      <input
        type="text"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder={searchPlaceholder}
        style={{
          flex: '1 1 240px',
          minWidth: '200px',
          padding: '8px 12px',
          borderRadius: '6px',
          border: `1px solid ${theme.border}`,
          backgroundColor: theme.surface,
          color: theme.text,
          fontSize: '14px',
        }}
      />
      <select
        value={timeRange}
        onChange={(e) => onTimeRangeChange(e.target.value as TimeRange)}
        title={search ? 'Search always looks across all history' : 'How far back to load'}
        style={{
          padding: '8px 12px',
          borderRadius: '6px',
          border: `1px solid ${theme.border}`,
          backgroundColor: theme.surface,
          color: theme.text,
          fontSize: '14px',
        }}
      >
        <option value="30">Last 30 days</option>
        <option value="90">Last 90 days</option>
        <option value="365">Last year</option>
        <option value="all">All time</option>
      </select>
    </div>
  );
};

export default HistorySearchBar;
